import React, { useState } from 'react';
import './IconSelector.css';

const IconSelector = ({ icon, setIcon }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleIconClick = (value) => {
    setIcon(value);
    setIsOpen(false); // Cierra el desplegable después de seleccionar un icono
  };

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="icon-selector-container">
      <label htmlFor="icon">Selecciona un icono</label>
      <div className="icon-display" onClick={toggleDropdown}>
        {icon ? <i className={icon}></i> : 'Selecciona un icono'}
      </div>
      {isOpen && (
        <div className="icon-selector">
          <button
            type="button"
            className={`icon-button ${icon === 'fi fi-sr-key' ? 'selected' : ''}`}
            onClick={() => handleIconClick('fi fi-sr-key')}
          >
            <i className="fi fi-sr-key"></i>
          </button>
          <button
            type="button"
            className={`icon-button ${icon === 'fi fi-ss-diamond' ? 'selected' : ''}`}
            onClick={() => handleIconClick('fi fi-ss-diamond')}
          >
            <i className="fi fi-ss-diamond"></i>
          </button>
          <button
            type="button"
            className={`icon-button ${icon === 'fi fi-sr-treasure-chest' ? 'selected' : ''}`}
            onClick={() => handleIconClick('fi fi-sr-treasure-chest')}
          >
            <i className="fi fi-sr-treasure-chest"></i>
          </button>
          <button
            type="button"
            className={`icon-button ${icon === 'fi fi-sr-coins' ? 'selected' : ''}`}
            onClick={() => handleIconClick('fi fi-sr-coins')}
          >
            <i className="fi fi-sr-coins"></i>
          </button>
          <button
            type="button"
            className={`icon-button ${icon === 'fi fi-rr-newspaper' ? 'selected' : ''}`}
            onClick={() => handleIconClick('fi fi-rr-newspaper')}
          >
            <i className="fi fi-rr-newspaper"></i>
          </button>
          {/* Añade más botones según sea necesario */}
        </div>
      )}
    </div>
  );
};

export default IconSelector;
